<i18n src="@/locales/components/RequestNotificationStepsConfigTranslate.json"></i18n>

<template>
	<form @submit.prevent="" autocomplete="off" class="cbs-request-notification-steps-config">
		<div :class="['mb-5', { flex: !isEditable }]">
			<legend :class="{ 'w-1/3 sm:w-1/4': !isEditable }">
				{{ $t("Name") }}
				<span class="text-danger" v-if="isEditable && (isRequiredName || (isRequiredIfAny && isHasConfigValue))">&nbsp;*</span>:
			</legend>
			<cbs-input
				v-if="isEditable"
				name="name"
				class="inputx w-full"
				v-model="value.name"
				v-validate="isRequiredName || (isRequiredIfAny && isHasConfigValue) ? 'required' : ''"
				:data-vv-as="$t('Name')"
				:placeholder="`${$t('Actions.Input')} ${$t('Name').toLowerCase()}`"
			/>
			<div v-else class="w-2/3 sm:w-3/4 text-black">{{ value.name }}</div>
			<span class="text-danger text-sm">{{ errors.first("name") }}</span>
		</div>

		<RequestNotificationConfig v-model="value.config" :isReadonly="!isEditable" :isRequired="isRequiredConfig || (isRequiredIfAny && (isHasNameValue || isHasConfigValue))" :stepId="value.id" />
	</form>
</template>

<script>
import RequestNotificationConfig from "./RequestNotificationConfig";

export default {
	inject: ["parentValidator"],
	name: "RequestNotificationStepsConfig",
	components: { RequestNotificationConfig },
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => {
				return prop.hasOwnProperty("name") && prop.hasOwnProperty("config");
			}
		},
		isEditable: {
			type: Boolean,
			default: false
		},
		isRequiredName: {
			type: Boolean,
			default: false
		},
		isRequiredConfig: {
			type: Boolean,
			default: false
		},
		isRequiredIfAny: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		isHasApproversConfigContentValue() {
			return !!this.value.config.approversConfig.content;
		},
		isHasApproversConfigTargetValue() {
			return this.value.config.approversConfig.relations && this.value.config.approversConfig.relations.length > 0;
		},
		isHasApprovedNotificationConfigContentValue() {
			return !!this.value.config.approvedNotificationConfig.content;
		},
		isHasApprovedNotificationConfigTargetValue() {
			return this.value.config.approvedNotificationConfig.relations && this.value.config.approvedNotificationConfig.relations.length > 0;
		},
		isHasRejectedNotificationConfigContentValue() {
			return !!this.value.config.rejectedNotificationConfig.content;
		},
		isHasRejectedNotificationConfigTargetValue() {
			return this.value.config.rejectedNotificationConfig.relations && this.value.config.rejectedNotificationConfig.relations.length > 0;
		},
		isHasConfigValue() {
			return (
				this.isHasApproversConfigContentValue ||
				this.isHasApproversConfigTargetValue ||
				this.isHasApprovedNotificationConfigContentValue ||
				this.isHasApprovedNotificationConfigTargetValue ||
				this.isHasRejectedNotificationConfigContentValue ||
				this.isHasRejectedNotificationConfigTargetValue
			);
		},
		isHasNameValue() {
			return !!this.value.name;
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>
